<script setup lang="ts">
import {
  ParagraphTimelineItem,
  ParagraphOverlayAccordionItem,
  MediaDocument,
  MediaImageFragment,
} from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphTimelineItem
}>()

const image = computed(() => {
  if (!props.entity.fieldImage) return null
  return props.entity.fieldImage?.entity as MediaImageFragment
})

const accordionItems = computed(() => {
  if (!props.entity.fieldItems || props.entity.fieldItems?.length < 1) return null
  return props.entity.fieldItems?.map((item) => {
    const typeCorrectItem = item?.entity as ParagraphOverlayAccordionItem
    return {
      title: typeCorrectItem.fieldTitle,
      description: typeCorrectItem.fieldText?.processed,
    }
  })
})

const downloadItems = computed(() => {
  if (!props.entity.fieldDownloadItems || props.entity.fieldDownloadItems.length < 1) return []
  return (
    props.entity.fieldDownloadItems.map((item) => {
      const typeCorrectItem = item?.entity as MediaDocument
      return {
        title: typeCorrectItem.name || '',
        type: typeCorrectItem.fieldMediaDocument?.entity?.filemime || '',
        size: typeCorrectItem.fieldMediaDocument?.entity?.filesize || '',
        url: typeCorrectItem.fieldMediaDocument?.entity?.url || '',
      }
    }) || []
  )
})

const cta = computed(() => {
  if (!props.entity.fieldLink) return null

  console.log(props.entity.fieldLink)
  return {
    url: props.entity.fieldLink?.url?.path ?? '',
    target: props.entity.fieldLink?.options?.attributes.target || '_self',
    text: props.entity.fieldLink?.title ?? '',
  }
})
</script>

<template>
  <div class="modal-content-container">
    <div v-if="image" class="overlay-image-container">
      <Image :entity="image" type="teaser" />
    </div>
    <h1 class="field-overlay-title">{{ entity.fieldOverlayTitle }}</h1>
    <p>{{ entity.fieldOverlayLead }}</p>
    <div class="overlay-text" v-html="entity.fieldText?.processed" />
    <Accordion>
      <AccordionItem v-for="(item, index) in accordionItems" :key="index" :index="index" :title="item.title || ''">
        <div v-html="item.description" />
      </AccordionItem>
    </Accordion>
    <Downloads :items="downloadItems" />
    <Button v-if="cta" primary :to="cta.url" :target="cta.target">
      {{ cta.text }}
    </Button>
  </div>
</template>

<style scoped lang="scss">
.modal-content-container {
  padding-left: 24px;
  .overlay-image-container {
    height: 340px;
    left: 0;
    overflow: hidden;
    position: absolute;
    top: 0;
    width: 100%;
    @include breakpoint(tl) {
      height: 440px;
    }
    .dp-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    + .field-overlay-title {
      padding-top: 300px;
      @include breakpoint(tl) {
        padding-top: 400px;
      }
      @include breakpoint(ds) {
        padding-top: 360px;
      }
    }
  }
}
</style>
